import { render, staticRenderFns } from "./Catalog-Sort.vue?vue&type=template&id=0236f0c4&lang=pug"
import script from "./Catalog-Sort.vue?vue&type=script&setup=true&lang=ts"
export * from "./Catalog-Sort.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports